import SalesAdvertisingPlanReport from './salesAdvertisingPlanReportPage';

export default SalesAdvertisingPlanReport;
